import React from "react";
import Marquee from "react-fast-marquee";
import { Lightning } from "@phosphor-icons/react";

export default function SaleMarquee() {
  const items = ["STOREWIDE SALE", "FANTASTIC DEALS", "GET CONNECTED", "SPONSORED SPOTS OPEN", "FRESH LINKS DAILY"];
  return (
    <div className="bg-[#FFD600] border-y-2 border-black py-2 overflow-hidden">
      <Marquee speed={60} gradient={false}>
        {items.concat(items).map((t, i) => (
          <span key={`${t}-${i}`} className="font-display font-black text-black uppercase text-sm tracking-tight mx-8 flex items-center gap-3">
            <Lightning size={16} weight="fill" /> {t}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
